import ConfirmEmailFailure from './ConfirmEmailFailure';

export default ConfirmEmailFailure;